var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loller"},[_c('Seperator'),_c('Home_slider')],1),_c('Seperator'),_c('div',{staticClass:"lol"},[_c('Devider')],1),_c('Franquicias'),_c('Mapper'),_c('div',{staticClass:"skew-btm-whitesmoke"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }